module.exports = __webpack_public_path__ + "img/73800.6147d804.jpg";